import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-autosave-textarea',
  standalone: true,
  imports: [NgIf, ReactiveFormsModule],
  templateUrl: './autosave-textarea.component.html',
  styleUrl: './autosave-textarea.component.css'
})

export class AutosaveTextareaComponent implements OnInit {
  @Input() text: string = '';
  @Input() autoSaveDelayMilliseconds = 1000;
  @Input() watermark = 'Type something...'
  @Output() autosave = new EventEmitter<string>();

  textareaControl = new FormControl('');
  saved = false;

  private destroy$ = new Subject<void>();
  private suppressChange = false;

  ngOnInit() {
    // preload value
    this.textareaControl.setValue(this.text || '');

    // emit autosave events when user stops typing
    this.textareaControl.valueChanges
      .pipe(
        debounceTime(this.autoSaveDelayMilliseconds),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe((value) => {
        this.autosave.emit(value ?? '');
        this.showSavedIndicator();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['text'] && !changes['text'].firstChange) {
      const newVal = changes['text'].currentValue ?? '';
      if (newVal !== this.textareaControl.value) {
        this.suppressChange = true;
        this.textareaControl.setValue(newVal, { emitEvent: false });
        this.suppressChange = false;
      }
    }
  }

  private showSavedIndicator() {
    this.saved = true;
    setTimeout(() => (this.saved = false), 800);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
